import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    super('restaurants', {
      detail: {
        restaurant: null,
        dishes: [],
        loading: false,
        error: null,
      },
    });

    this.setupEvents();
  }

  setupEvents() {
    // ============ DETAIL EVENTS ============
    this.on(constants.EVENTS.RESTAURANT.RESTAURANT_DETAIL_LOADING, () => {
      this.state.detail.loading = true;
      this.state.detail.error = null;
    });

    this.on(constants.EVENTS.RESTAURANT.RESTAURANT_DETAIL_LOADED, (data) => {
      this.state.detail.restaurant = data.restaurant || data;
      // Only update dishes if explicitly provided in this payload (backward compatibility)
      if (data.dishes) this.state.detail.dishes = data.dishes;
      this.state.detail.loading = false;
      this.state.detail.error = null;
    });

    this.on(constants.EVENTS.RESTAURANT.DISHES_LOADED, (dishes) => {
      this.state.detail.dishes = dishes || [];
    });

    this.on(constants.EVENTS.RESTAURANT.RESTAURANT_DETAIL_ERROR, (error) => {
      this.state.detail.loading = false;
      this.state.detail.error = error?.message || error;
      this.state.detail.restaurant = null;
    });

    this.on(constants.EVENTS.RESTAURANT.DISHES_ERROR, (error) => {
      console.error('[Store] Dishes load error:', error);
    });
  }

  // Getters
  get restaurantDetail() {
    return this.state.detail.restaurant;
  }

  get restaurantDishes() {
    return this.state.detail.dishes;
  }

  get isLoading() {
    return this.state.detail.loading;
  }

  get hasError() {
    return !!this.state.detail.error;
  }

  get error() {
    return this.state.detail.error;
  }
}

export default Store;
